import Vue from 'vue'
import Vuex from 'vuex'
import config from './module/config';


Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        LOADING: false,
        AUDIO_PLAYER_OVERLAYS: 0,
    },
    getters: {
    },
    mutations: {
        showLoading(state) {
            state.LOADING = true;
        },

        hideLoading(state) {
            state.LOADING = false;
        },
        addAudioPlayerOverlay(state) {
            state.AUDIO_PLAYER_OVERLAYS += 1
        },
        removeAudioPlayerOverlay(state) {
            state.AUDIO_PLAYER_OVERLAYS = Math.max(0, state.AUDIO_PLAYER_OVERLAYS - 1)
        },
    },
    actions: {
    },
    modules: {
        config
    }
})

export default store
